import { useCookies } from 'react-cookie';
import React, { lazy, Suspense } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import Layout from './component/layout';
import Member from './common/model/member';
import { MemberProvider } from './context/member';

const Main = lazy(() => import('./view/main'));
const About = lazy(() => import('./view/about'));
const Activity = lazy(() => import('./view/activity'));
const ActivityPost = lazy(() => import('./view/activity-post'));
const Kukie = lazy(() => import('./view/kukie'));
const Game = lazy(() => import('./view/game'));

function App() {
  const [token, setToken, removeToken] = useCookies(['accessToken']);

  let member = null as Member;
  try {
    // const { data } = jwt.verify(token.accessToken, process.env.REACT_APP_JWT_SECRET) as {
    //   data: Member;
    // };
    // member = data;
  } catch (e) {
    removeToken('accessToken');
  }

  return (
    <Router>
      <MemberProvider member={member}>
        <Layout>
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Main/>} />
              <Route path="/about" element={<About/>} />
              <Route path="/activity/:id" element={<ActivityPost/>} />
              <Route path="/activity" element={<Activity/>} />
              <Route path="/kukie" element={<Kukie/>} />
              <Route path="/game" element={<Game/>} />
              <Route path="*" element={<Main/>} />
            </Routes>
          </Suspense>
        </Layout>
      </MemberProvider>
    </Router>
  );
}

export default App;
